import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIRoutes } from "APIRoutes";
import axios from "utils/axios";
import { utils } from "utils/utils";

export interface DashboardDto {
  statsLoader: boolean;
  statistics: {};
  recentRequestsLoader: boolean;
  recentRequests: any[];
  yearlyLoader: boolean;
  yearlyRequests: {};
  serviceAnalyticsLoader: boolean;
  serviceAnalytics: {};
  filters: {
    city: any;
    analytics: {
      startDate: string;
      endDate: string;
    };
    overall: {
      startDate: string;
      endDate: string;
    };
  };
}

export const getStatistics = createAsyncThunk(
  "dashboard/getStatistics",
  async (params: any) => {
    const response: any = await axios.get(
      `${APIRoutes.DASHBOARD_STATISTICS}?${params}`
    );
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return { data: response?.data?.data ?? {} };
  }
);

export const getYearlyRequests = createAsyncThunk(
  "dashboard/getYearlyRequests",
  async (params: any) => {
    const response: any = await axios.get(
      `${APIRoutes.DASHBOARD_YEARLY_STATISTICS}?${params}`
    );
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return { data: response?.data ?? {} };
  }
);

export const getServiceAnalytics = createAsyncThunk(
  "dashboard/getServiceAnalytics",
  async (params: any) => {
    const response: any = await axios.get(
      `${APIRoutes.DASHBOARD_SERVICE_ANALYTICS}?${params}`
    );
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    console.log("getServiceAnalytics", response?.data);
    return { data: response?.data ?? {} };
  }
);

export const getRecentRequests = createAsyncThunk(
  "dashboard/getRecentRequests",
  async (params: any) => {
    const response: any = await axios.get(
      `${APIRoutes.DASHBOARD_RECENT_REQUESTS}?${params}`
    );
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return { data: response?.data?.data ?? {} };
  }
);

export const setDashboardFilters = createAsyncThunk(
  "dashboard/setDashboardFilters",
  async (filters: any) => {
    return { filters };
  }
);

const initialState: DashboardDto = {
  statsLoader: false,
  statistics: {},
  recentRequestsLoader: false,
  recentRequests: [],
  yearlyLoader: false,
  yearlyRequests: {},
  serviceAnalyticsLoader: false,
  serviceAnalytics: {},
  filters: {
    city: null,
    analytics: {
      startDate: "",
      endDate: "",
    },
    overall: {
      startDate: "",
      endDate: "",
    },
  },
};

export const dashboard = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStatistics.pending, (state) => {
        state.statsLoader = true;
      })
      .addCase(getStatistics.fulfilled, (state, { payload }) => {
        state.statsLoader = false;
        state.statistics = payload?.data;
      })
      .addCase(getStatistics.rejected, (state) => {
        state.statsLoader = false;
      })
      // getting yearly requests
      .addCase(getYearlyRequests.pending, (state) => {
        state.yearlyLoader = true;
      })
      .addCase(getYearlyRequests.rejected, (state) => {
        state.yearlyLoader = false;
      })
      .addCase(getYearlyRequests.fulfilled, (state, { payload }) => {
        state.yearlyLoader = false;
        state.yearlyRequests = payload?.data;
      })

      // getting service analytics
      .addCase(getServiceAnalytics.pending, (state) => {
        state.serviceAnalyticsLoader = true;
      })
      .addCase(getServiceAnalytics.rejected, (state) => {
        state.serviceAnalyticsLoader = false;
      })
      .addCase(getServiceAnalytics.fulfilled, (state, { payload }) => {
        state.serviceAnalyticsLoader = false;
        state.serviceAnalytics = payload?.data;
      })

      .addCase(setDashboardFilters.fulfilled, (state, { payload }) => {
        state.serviceAnalyticsLoader = false;
        state.filters = payload?.filters;
      })

      // getting recent requests
      .addCase(getRecentRequests.fulfilled, (state, { payload }) => {
        state.recentRequests = payload?.data;
        state.recentRequestsLoader = false;
      })
      .addCase(getRecentRequests.pending, (state, { payload }) => {
        state.recentRequestsLoader = true;
      })
      .addCase(getRecentRequests.rejected, (state, { payload }) => {
        state.recentRequestsLoader = false;
      });
  },
});

export default dashboard.reducer;
